import Cookies from './Cookies'
import Privacy from './Privacy'

const Legal = {
	Cookies,
	Privacy
}

export default Legal